// Pages dédiées aux insectes xylophages — contenu unique, expert, fortement localisé Bordeaux
import { SITE } from "./site";

const COMMON_HUB_SCHEMA_OFFER = (name, desc) => ({
  "@type": "Service",
  serviceType: name,
  name,
  description: desc,
  provider: {
    "@type": "LocalBusiness",
    name: SITE.name,
    telephone: SITE.phoneRaw,
    address: {
      "@type": "PostalAddress",
      streetAddress: SITE.address,
      postalCode: SITE.postalCode,
      addressLocality: SITE.city,
      addressRegion: SITE.region,
      addressCountry: "FR",
    },
  },
  areaServed: { "@type": "AdministrativeArea", name: "Gironde, France" },
});

export const INSECTS = [
  {
    slug: "capricornes",
    title: "Capricornes des maisons",
    h1: "Traitement capricornes à Bordeaux & en Gironde",
    seoTitle: "Traitement Capricornes Bordeaux — Termite Bordeaux",
    description:
      "Capricornes des maisons (Hylotrupes bajulus) : reconnaître, traiter et garantir une charpente saine à Bordeaux et en Gironde. Cabinet expert, devis 48 h, garantie 5 ans.",
    keywords: ["capricornes Bordeaux", "capricorne charpente Bordeaux", "Hylotrupes bajulus Gironde", "traitement capricornes Gironde"],
    cover: "https://images.unsplash.com/photo-1690818676619-c55d2cf9c3b6?auto=format&fit=crop&w=1600&q=80",
    intro:
      "Le capricorne des maisons est le coléoptère xylophage le plus destructeur des charpentes en pin maritime et en sapin, omniprésent dans le bâti girondin. Sans traitement, une charpente peut être totalement compromise en 5 à 10 ans.",
    sections: [
      { type: "h2", text: "Biologie et cycle de vie" },
      { type: "p", text:
        "Hylotrupes bajulus est un coléoptère de 8 à 20 mm, brun à noir, avec deux taches claires sur les élytres. La femelle pond 200 à 400 œufs dans les fissures des bois résineux. Les larves, blanches et bombées, creusent ensuite des galeries pendant 3 à 11 ans avant la nymphose. À leur sortie à l'âge adulte, elles laissent des trous ovales de 6 à 10 mm." },
      { type: "h2", text: "Signes d'une infestation à Bordeaux" },
      { type: "ul", items: [
        "Bruit de mastication audible la nuit (parfois entendu en plafond)",
        "Sciure granuleuse au pied des poutres",
        "Trous ovales caractéristiques (6 à 10 mm de longueur)",
        "Bois qui sonne creux et part en poussière",
        "Galeries longues, larges, à parois lisses",
      ]},
      { type: "h2", text: "Pourquoi Bordeaux est particulièrement exposée" },
      { type: "p", text:
        "Le pin maritime, omniprésent en Gironde et utilisé massivement en charpente jusqu'aux années 1980, est le bois préféré du capricorne. À cela s'ajoute la chaleur d'été et l'humidité relative élevée de la métropole bordelaise, qui accélèrent le cycle larvaire. Les communes de Mérignac, Pessac, Saint-Médard-en-Jalles, et l'ensemble du Bassin d'Arcachon connaissent une forte densité." },
      { type: "h2", text: "Notre protocole de traitement" },
      { type: "p", text:
        "Étape 1 : sondage acoustique systématique de l'ensemble de la charpente pour cartographier les zones colonisées. Étape 2 : bûchage manuel des bois fortement altérés pour atteindre le bois sain. Étape 3 : pulvérisation à basse pression d'un produit insecticide certifié CTB‑P+, suivie d'une injection à cœur tous les 30 cm dans les pièces de bois épaisses (chevrons, sablières, entraits)." },
      { type: "h2", text: "Coût indicatif à Bordeaux" },
      { type: "p", text:
        "Comptez 30 à 55 € HT du m² de charpente traitée. Pour une maison individuelle bordelaise de 100 m² au sol, soit environ 120 m² de charpente, le budget moyen tourne autour de 4 500 à 7 000 € HT." },
      { type: "h2", text: "Garantie" },
      { type: "p", text:
        "Garantie 5 ans : si une nouvelle activité de capricornes est constatée dans les 5 ans suivant notre intervention, nous revenons traiter à nos frais — aucun euro à votre charge." },
    ],
  },
  {
    slug: "vrillettes",
    title: "Vrillettes",
    h1: "Traitement des vrillettes à Bordeaux & en Gironde",
    seoTitle: "Traitement Vrillettes Bordeaux — Termite Bordeaux",
    description:
      "Petites et grosses vrillettes : identifier, traiter et préserver le bois ancien de votre habitat bordelais. Expertise gratuite, devis 48 h, garantie 5 ans.",
    keywords: ["vrillettes Bordeaux", "petite vrillette Bordeaux", "Anobium punctatum", "Xestobium rufovillosum", "vrillettes Gironde"],
    cover: "https://images.unsplash.com/photo-1632485904373-3ee3a74aa74b?auto=format&fit=crop&w=1600&q=80",
    intro:
      "Les vrillettes sont les coléoptères xylophages les plus répandus dans les maisons anciennes bordelaises. Présentes dans les meubles, parquets, escaliers et solives, elles fragilisent en silence le bois noble pendant des années.",
    sections: [
      { type: "h2", text: "Petite vrillette (Anobium punctatum) vs grosse vrillette (Xestobium rufovillosum)" },
      { type: "p", text:
        "La petite vrillette est l'insecte que l'on retrouve le plus souvent dans les meubles anciens, parquets en chêne et solives. Elle perce de petits trous ronds de 1 à 3 mm et laisse une fine poussière ocre. La grosse vrillette, plus rare mais redoutable, s'installe surtout dans les bois humidifiés (caves, charpentes infiltrées) et perce des trous de 3 à 6 mm." },
      { type: "h2", text: "Signes d'infestation" },
      { type: "ul", items: [
        "Petits trous ronds (1 à 6 mm selon l'espèce)",
        "Sciure très fine, comme du sable beige",
        "Trous récents : présence d'un petit cône de sciure dessous",
        "Bruit de tic-tac discret (grosse vrillette) — d'où son surnom 'horloge de la mort'",
        "Bois qui se déforme aux abords des galeries",
      ]},
      { type: "h2", text: "Pourquoi le bâti bordelais est exposé" },
      { type: "p", text:
        "Les Chartrons, Saint-Pierre, Saint-Michel, Caudéran : autant de quartiers où abondent meubles d'époque, parquets en chêne et boiseries. La petite vrillette y est endémique. Quant à la grosse vrillette, elle s'attaque aux caves voûtées humides typiques des hôtels particuliers du XVIIIᵉ siècle, en particulier près de la Garonne." },
      { type: "h2", text: "Notre traitement curatif" },
      { type: "p", text:
        "Inspection et sondage à la lampe puis traitement bois en deux passes : pulvérisation surface large + injection à cœur sous pression pour les pièces porteuses. Sur le mobilier ancien de valeur, nous utilisons un traitement gaz à l'azote (anoxie) sur 3 semaines, totalement inoffensif pour les vernis et les marqueteries." },
      { type: "h2", text: "Tarifs indicatifs" },
      { type: "p", text:
        "Petites surfaces (escaliers, plinthes, mobilier) : forfait 350 à 900 € HT. Traitement de parquet ancien complet : 25 à 45 € HT du m². Charpente : 30 à 55 € HT du m²." },
    ],
  },
];

export const INSECTS_HUB = {
  title: "Insectes xylophages à Bordeaux : guide complet",
  description:
    "Termites, capricornes, vrillettes, lyctus : tout savoir sur les insectes xylophages qui menacent l'habitat bordelais et girondin. Protocoles, prix, garanties.",
  keywords: [
    "insectes xylophages Bordeaux",
    "insectes xylophages Gironde",
    "bois infesté Bordeaux",
    "traitement insectes bois Bordeaux",
  ],
  schemaOffers: [
    COMMON_HUB_SCHEMA_OFFER("Traitement capricornes", "Traitement curatif des capricornes des maisons"),
    COMMON_HUB_SCHEMA_OFFER("Traitement vrillettes", "Traitement curatif des petites et grosses vrillettes"),
    COMMON_HUB_SCHEMA_OFFER("Traitement termites", "Traitement curatif et préventif des termites souterrains"),
    COMMON_HUB_SCHEMA_OFFER("Traitement lyctus", "Traitement des lyctus dans les bois feuillus"),
  ],
};

export const getInsect = (slug) => INSECTS.find((i) => i.slug === slug);
